import { render, staticRenderFns } from "./personalDetails.html?vue&type=template&id=38a02f4f&"
import script from "./personalDetails.js?vue&type=script&lang=js&"
export * from "./personalDetails.js?vue&type=script&lang=js&"
import style0 from "./personalDetails.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports